import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';
import { SKIP_AUTH, SKIP_AUTH_ERROR } from './auth-context';
import { buildAllowedOrigins, isAllowedOrigin } from '../utils/auth-origins';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly allowedOrigins = buildAllowedOrigins();

  constructor(private readonly authService: AuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.context.get(SKIP_AUTH)) {
      return next.handle(req);
    }

    if (!this.shouldAttachToken(req.url)) {
      return next.handle(req);
    }

    if (req.headers.has('Authorization')) {
      return next.handle(req);
    }

    return from(this.authService.getAccessToken()).pipe(
      switchMap((token) => {
        if (!token) {
          const safeReq = req.clone({
            context: req.context.set(SKIP_AUTH_ERROR, true),
          });
          return next.handle(safeReq);
        }
        const authReq = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
        return next.handle(authReq);
      })
    );
  }

  private shouldAttachToken(url: string): boolean {
    return isAllowedOrigin(url, this.allowedOrigins);
  }
}
